module.exports = __webpack_public_path__ + "843143ad5c72768caaefafc93f5d007a.pdf";